import React from "react";
import "./HomeHeader.css";

function HomeHeader() {
  return (
    <div className="wrapper-header">
      <div className="container-header">
        <p
          style={{
            margin: 0,
            fontSize: 24,
            fontWeight: "bold",
            color: "white",
          }}
        >
          댕친소
        </p>
      </div>
    </div>
  );
}

export default HomeHeader;
